import React,{useRef,useEffect,useState} from 'react';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import ManageInventoryPurchaseOrder from './receiveProducts/ManageInventoryPurchaseOrder'
import ManageInventoryOptions from './ManageInventoryOptions'
import ReturnProducts from './returnProducts/ReturnProducts'
import RecordActualInvetory from './recordActualInventory/RecordActualInvetory'
import ComputeReorder from './computeReorder/ComputeReorder'
import ViewSalesInvoiceSummary from './viewSalesInvoiceSummary/ViewSalesInvoiceSummary'
import TransferStocks from './transferStocks/TransferStocks'
import ViewInventorySummary from './viewInventorySummary/ViewInventorySummary'
import {useHistory,useLocation} from 'react-router-dom'
import axios from 'axios'
const drawerWidth = 300;


const useStyles = makeStyles((theme) => ({
  appBar: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    roota: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
      },
  },

}));

function ManageInventoryMain(props) {

    const classes = useStyles();
    const {search} = useLocation()
    const [viewing,setViewing] = useState()
    const history = useHistory()
    const [returnProductPageSettings, setReturnProductPageSettings] = useState(1);
    
    useEffect(() => {
      const viewing = new URLSearchParams(search).get('viewing')
      setViewing(viewing)
      getReturnProductPageSettings();
    });

    const getReturnProductPageSettings = async () => {

      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/fetchExistingReturnProductPageSettings.json',
      }

      await axios(options)
      .then((res) => {

          
        const message = res.data.response.message;
        const is_success = res.data.response.is_success;
        const settings = parseInt(res.data.response.settings) === 1 ? true : false;

        setReturnProductPageSettings(settings)
      })
      .catch((error) => {

      })
    }
    const optionMenuBtnOnClickHandler = (event)=>{

     
      const view = event.currentTarget.getAttribute('view')
      
       history.push({
         pathname:'/manageInventory',
         search:`?viewing=${view}`
       })
    
    }
    
    if(viewing === 'received_products'){

      return(
        <div>
          <ManageInventoryPurchaseOrder handleDrawerToggle={props.handleDrawerToggle}/>
        </div>
      )

    }

    if(viewing == 'return_products' && returnProductPageSettings){
        return(
          <div>
            <ReturnProducts handleDrawerToggle={props.handleDrawerToggle}/>
          </div>  
        )
    }

    if(viewing == 'record_actual_inventory'){
      return(
        <div>
          <RecordActualInvetory handleDrawerToggle={props.handleDrawerToggle}/>
        </div>  
      )
  }
    
  if(viewing == 'compute_reorder_quantity'){
    return(
      <div>
        <ComputeReorder handleDrawerToggle={props.handleDrawerToggle}/>
      </div>  
    )
  }
  if(viewing == 'view_sales_invoice_summary'){
   return(
     <div>
       <ViewSalesInvoiceSummary handleDrawerToggle={props.handleDrawerToggle}/>
        
     </div>
   )
  }

  if(viewing == 'transfer_inventory'){
    return(
      <div>
        <TransferStocks handleDrawerToggle={props.handleDrawerToggle}/>
         
      </div>
    )
   }
   if(viewing == 'view_inventory_summary'){
    return(
      <div>
        <ViewInventorySummary handleDrawerToggle={props.handleDrawerToggle}/>
         
      </div>
    )
   }
    return (
        <div>

            {/* <ManageInventoryPurchaseOrder handleDrawerToggle={props.handleDrawerToggle}/> */}
       
       <ManageInventoryOptions returnProductPageSettings={returnProductPageSettings}  handleDrawerToggle={props.handleDrawerToggle} optionMenuBtnOnClickHandler={optionMenuBtnOnClickHandler}/>
             {/* <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={props.handleDrawerToggle}
                    className={classes.menuButton}
                >
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap>
                   Manage Inventory
                </Typography>
                </Toolbar>
            </AppBar>  */}

        </div>
    )
}

export default ManageInventoryMain